export enum GlitchLogic {
  None,
  Overworld,
  Major
}
